import { Component, input, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from 'src/app/shared/emr-list/emr-list.component';

import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { GeneralAppearanceAssessment } from 'src/app/calvin-emr-shared/models/assessments/general-appearance.model';

@Component({
  selector: 'app-general-appearance-info',
  templateUrl: './general-appearance-info.component.html',
  styleUrls: ['./general-appearance-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent, EmrListComponent],
})
export class GeneralAppearanceInfoComponent
  extends AssessmentInfoComponent<GeneralAppearanceAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }

  get isLethargic() {
    return this.data().lethargic ? 'Yes' : 'No';
  }

  get isInappropriateForAge() {
    return this.data().inappropriateForAge ? 'Yes' : 'No';
  }

  get inDistress() {
    return this.data().distress ? 'Yes' : 'No';
  }
}
